<template>
    <div>
    <v-dialog v-model="dialog" width="1200px">
        <v-card>
            <v-form ref="viewProcessingHsft" v-model="reviveHsftValid">
            <v-card-title class="justify-center">View processing photo's {{ huisprocessing.huis_code }}</v-card-title>
            <v-divider/>
            <div class="scrollable">
                <v-row no-gutters>
                    <v-col v-for="p in huisprocessing.hsft_aant" :key="p" id="content" class="pa-2" cols=2>
                        <figure>
                            <figcaption>&nbsp; {{ huisprocessing.hsft[parseInt(p) - 1].hsft_nr }}</figcaption>
                            <img :src="huisprocessing.hsft[parseInt(p) - 1].hsft_foto" class="px-1" :title="huisprocessing.hsft[parseInt(p) - 1].hsft_tag"><br>
                            <figcaption class="my-0 red--text" v-if="huisprocessing.hsft[parseInt(p) - 1].hsft_status == 'Error'">{{ huisprocessing.hsft[parseInt(p) - 1].hsft_hash }}</figcaption>
                            <figcaption class="my-0 orange--text" v-if="huisprocessing.hsft[parseInt(p) - 1].hsft_status == 'Processing'">Processing...</figcaption>
                            <!-- <v-checkbox v-model="selected" :value="huisprocessing.hsft[parseInt(p) - 1].hsft_encrid" :rules="selected_checks" label="Back to live" class="my-0"></v-checkbox>  -->
                        </figure>                         
                    </v-col>
                </v-row>
            </div>
            
                
            <v-divider/>
            <v-row v-if="huisprocessing.hsft.length == 0" dense class="pa-2 ma-0" cols="12">
                <span class="px-4">No photo's are being processed at this moment</span>
            </v-row>
            <!--
            <v-row dense class="pa-2 ma-0" cols="12">
                <span class="px-4" v-if="selected.length>0">{{ selected.length }} Photo's selected</span>
                <span class="px-4" v-else>No photo's selected</span>
                <v-spacer></v-spacer>
                <span :style="{ color: 'red' }" v-if="confirmCounter > 0">Press "confirm copy" to confirm copy of the Photo's ({{ confirmCounter }})</span>
                <span :style="{ color: 'red' }" v-else>{{ message }}</span>
            </v-row>
            -->
            <v-divider/>
            </v-form>
            <v-card-actions>
                <!-- <v-btn color="primary" small @click="selectAll()">Select All</v-btn>
                <v-btn color="primary" small @click="clearAll()">Clear selection</v-btn>-->
                <v-spacer/>
                <!-- <v-btn class="warning mr-3" small @click="reviveHsft()" :disabled="!reviveHsftValid">Revive Photo's</v-btn> -->
                <!-- <v-btn color="primary" small @click="restartProcessingHsft()">Restart Processing</v-btn> -->
                <v-btn color="primary" small @click="closeProcessingDialog()">Close</v-btn> 
            </v-card-actions>
        
        </v-card>
    </v-dialog>
    <v-dialog v-model="dialogbigdel" width="600px">
        <v-card>
            <p class=".title ma-2">{{ huisprocessing.huis_code }} </p>
            <v-img :src="this.bigimage" width="600" height="450"></v-img>
            <v-container>
                <v-row dense class="flex">
                    <v-spacer />

                
                    
                    <v-btn color="primary" small @click="dialogbigdel = false">Close</v-btn>
               
            </v-row>
            </v-container>
        </v-card>
    </v-dialog>
    
    </div>
</template>

<script>

    export default {
            components: {
        },
        data() { 
            return {
                huis_encrid: null,
                dialog: false,
                dialogbigdel: false,
                bigimage: null,
                reviveHsftValid: false,
                confirmTimer: null,
                confirmCounter: 0,
                fttg_nrKeuzes: [],
                hsft: {},
                hsft_array: [],
                huisprocessing: { hsft: []},
                selected: [],
                message: "",
                delCounter: 0,
                selected_checks: [
                    v => (v || '').length > 0 || 'Choose at least 1 photo to revive',
                ],
                items: [],
                isLoading: false,
                model: null,
                search: null,
            }
        },
        computed: {
            reactivePhotoArray: function () {
                return this.hsft_array.filter(() => {
                    return true;
                });
            }
        },
        methods: {
            open(huis_encrid) {
            this.huis_encrid = huis_encrid;
            this.$emit("showSnackbar");
            this.dialog = true;
            this.$axios
                .post("ares/json/ares/huis/hsft/getProcessingHsft.p", {
                header: {
                    token: this.$session.get("ARES"),
                    clientSessionId: this.$session.id(),
                    request: "getProcessingHsft"
                },
                getProcessingHsft: {
                    huis_encrid: huis_encrid
                }
                })
                .then(res => {
                if (res.data.error) {
                    console.log(res.data.error);
                } else {
                    this.huisprocessing = res.data.getProcessingHsft;
                }
                })
                .finally(() => {
                    this.selected = [];
                    this.loading = false;
                });
            },
            closeProcessingDialog() {
                this.dialog = false;
            },
            updateData() {
                this.getHuisData('update');
            },
            restartProcessingHsft(){
                this.$axios
                .post("ares/json/ares/huis/hsft/startProcessingHsft.p", {
                header: {
                    token: this.$session.get("ARES"),
                    clientSessionId: this.$session.id(),
                    request: "startProcessingHsft"
                },
                startProcessingHsft: {
                    huis_encrid: this.huis_encrid
                }
                })
                .then(res => {
                if (res.data.error) {
                    console.log(res.data.error);
                } else {
                    this.hsftprocessing = res.data.startProcessingHsft;
                }
                })
                .finally(() => {
                    
            });
            },
        }
    }
</script>

<style scoped>
    .flex{
        display: flex;
        flex-direction: row;
    }
    .scrollable {
        max-height: 600px;
        overflow-x: hidden;
        overflow-y: auto;
    }
</style>
